<div role="document">
  <header class="modal-header pb-0 px-4 mt-2">
    <h3 class="modal-title">Documentos necessários</h3>
    <a class="header__btn__close" (click)="activeModal.close(true)">
      <span aria-hidden="true">X</span>
    </a>
  </header>
  <main class="modal-body">
    <div class="col-12 mb-1">
      <b>
        Atenção! Antes de prosseguir com o preenchimento do formulário tenha em mãos os seguintes documentos.
      </b>
    </div>
    <section>
      <ul>
        <li class="mt-1" *ngIf="id == 6">Cópia do cartão bancário contendo dados da conta e nome completo (vedar o
          código de segurança) ou print do cabeçalo do extrato bancário.</li>
        <li class="mt-1" *ngIf="id == 4">Declaração particular conjunta de vida em comum registrada em cartório ou
          declaração conjunta/escritura pública de convivência.</li>
        <li class="mt-1" *ngIf="id == 5">Certidão de casamento;</li>
        <li class="mt-1" *ngIf="id == 1 || id == 2">RG, CPF ou CNH do Filho ou Enteado;</li>
        <li class="mt-1" *ngIf="id == 5">RG e CPF do Filho ou Enteado;</li>
        <li class="mt-1" *ngIf="id == 4">RG, CPF ou CNH do companheiro(a);</li>
      </ul>
    </section>
  </main>
  <footer class="modal-footer">
    <button class="btn btn-primary" (click)="closeModal()">
      Continuar
    </button>
  </footer>
  <div>